import * as React from "react"
import { HabitPrescriptionItemRequest, PrescriptionItemStatus } from "@curefit/gmf-common"
import {ILabtestPrescription} from "@curefit/care-common"
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import IStaticData from "../../../models/staticData/IStaticData";
import * as _ from "lodash";
import {AppConstants} from "../../../utils/AppConstants";
import {IHabitListItem} from "../../../models/LCPlanClientModels";

/**
 * Created by aditya on 28/06/18.
 */

let PatientHabitsPlansEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "dailyHabit", display: "DAILY HABIT"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "condition", display: "ADVICE"},
    {label: "reminder", display: "REMINDER"}
];


export interface PatientHabitsPlansEditorProps {
    fetchStaticLabTestsData?: (input: string) => Promise<any>,
    updatedHabitPlans: {item: IHabitListItem}[],
    updateHabitPlans: (updatedHabits: {item: IHabitListItem}[]) => void,
    fetchFitnessActivities?: (input: string) => Promise<any>;
    staticLifestyleHabits: IStaticData;
    savedHabitPlans?: any;
    updateSavedHabitPlans?: any;
}

class HabitPlansEditor extends React.Component<PatientHabitsPlansEditorProps> {

    constructor(props: PatientHabitsPlansEditorProps) {
        super(props);
    }

    onLabTestRemove = (index: number) => {
        let currUpdatedLabTests = Object.assign([], this.props.updatedHabitPlans);
        currUpdatedLabTests.splice(index, 1);
        this.props.updateHabitPlans(currUpdatedLabTests);
    }

    onLabTestChange = (updatedLifeStyle: ILabtestPrescription, index: number) => {
        let currUpdatedLabTest = Object.assign([], this.props.updatedHabitPlans);
        currUpdatedLabTest[index] = updatedLifeStyle;
        this.props.updateHabitPlans(currUpdatedLabTest);
    }

    onSavedHabitRemove = (index: number) => {
        let currUpdatedLifeStyle = Object.assign([], this.props.savedHabitPlans);
        let updatedFitnessPlan: { item: HabitPrescriptionItemRequest } = currUpdatedLifeStyle[index];
        updatedFitnessPlan.item.status = AppConstants.planStatus.CANCELLED as PrescriptionItemStatus;
        currUpdatedLifeStyle[index] = updatedFitnessPlan;
        this.props.updateSavedHabitPlans(currUpdatedLifeStyle);
    }

    render() {
        let consultationHeader = PatientHabitsPlansEditorHeaderInfos;
        let staticLifestyleHabits = this.props.staticLifestyleHabits;
        return (
            <div className="patient-habits-plan-editor">
                <CustomHeader headerInfos={consultationHeader} rootCls={"patient-habitsPlan"}/>
                <TemplatedList templateName={"habitsPlan"} commonProps={{ staticLifestyleHabits }}
                               defaultItem={{item: ModelFactory.createNewHabitPlanPrescriptionItem()}}
                               listItems={this.props.updatedHabitPlans}
                               onItemRemove={this.onLabTestRemove}
                               onItemChange={this.onLabTestChange}/>
            </div>
        );
    }
}

export default HabitPlansEditor